import { IsOptional, IsString, IsDateString } from 'class-validator'
import { ApiPropertyOptional } from '@nestjs/swagger'

export class UpdateSchoolYearDto {
  @ApiPropertyOptional({ type: 'string', description: "Code de l'année scolaire" })
  @IsOptional()
  @IsString()
  code?: string

  @ApiPropertyOptional({ type: 'string', description: "Nom de l'année scolaire" })
  @IsOptional()
  @IsString()
  name?: string

  @ApiPropertyOptional({ type: 'string', description: 'Date de début' })
  @IsOptional()
  @IsDateString()
  startDate?: Date

  @ApiPropertyOptional({ type: 'string', description: 'Date de fin' })
  @IsOptional()
  @IsDateString()
  endDate?: Date
}
